import { ErrorMessage, Form, Formik } from 'formik';
import Header from '../Header/Header';
import React, { useState, useRef, useEffect } from 'react'
import { reportsSettingsSchema } from './utilities/schema';
import { Select, SuccessModal, Loader, ICONS, getIcon } from '@ohif/ui';
import { _commonUrls, _reportSettingsUrls } from '@custom/Utils/constants/apiUrls';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { HospitalResult } from './types';
import reportsSettingsApi from '@custom/rtk-apis/report/reportsSettings';
import updateProfileImage from '@custom/rtk-apis/report/updateProfileImage';
import { submitReportsSettingsForm } from '@custom/rtk-apis/report/submitReportsSettingsForm';
import { customStyle, getCurrencyContact, getLocalPhoneNumber } from '@custom/Utils/utils';
import { closeUpdateModal } from '@custom/store/slices/report/submitReportsSettingsForm';
import { servicesManager } from '../../app/src/App';
import { useTheme } from "../../ui/src/contextProviders";
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
const ReportsSettings = () => {
    const [specialitites, setSpecialitities] = useState([]);
    const [countryCode, setCountryCode] = useState(['+91']);
    const [successModal, setSuccessModal] = useState(false);
    const [title, setTitle] = useState('');
    const dispatch = useDispatch<AppDispatch>();
    const { result: reportResult } = useSelector((state: RootState) => state.reportsSettingsResponse);
    const submitReportsSettingsFormResponse = useSelector((state: RootState) => state.submitReportsSettingsFormResponse)
    const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    const [profileImage, setProfileImage] = useState<string>('');
    const [initialValues, setInitialValues] = useState<Partial<HospitalResult>>({});
    const [countryList, setCountryList] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');
    const { uiNotificationService } = servicesManager.services
    const isDarkMode = useTheme();

    const fileInputRef = useRef(null);

    useEffect(() => {
        if (reportResult && Object.keys(reportResult).length > 0) {
            if (reportResult?.country) {
                fetchStates(reportResult?.country, '', 'state')
            }
            if (reportResult?.country && reportResult?.state) {
                fetchStates(reportResult?.country, reportResult?.state, 'city')
            }
        }
    }, [reportResult])

    const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

    useEffect(() => {
        if (reportResult && Object.keys(reportResult).length > 0) {
            setProfileImage(reportResult.hospitalLogo);
            const fetchedValues = {
                hospitalName: reportResult?.hospitalHeader?.hospitalName ? reportResult?.hospitalHeader?.hospitalName : reportResult?.hospitalName || '',
                specialitites: reportResult?.hospitalHeader?.specialitites?.length > 0
                    ? reportResult.hospitalHeader.specialitites
                    : reportResult?.specialitites || [],
                contactNumberCountryCode: reportResult?.hospitalHeader?.contactNumberCountryCode ? reportResult?.hospitalHeader?.contactNumberCountryCode : reportResult?.contactNumberCountryCode || '+91',
                contactNumber: getLocalPhoneNumber(reportResult?.hospitalHeader?.contactNumber ? reportResult?.hospitalHeader?.contactNumber : reportResult?.contactNumber),
                email: reportResult?.hospitalHeader?.email ? reportResult?.hospitalHeader?.email : reportResult?.hospitalEmailId || '',
                address: reportResult?.hospitalHeader?.address ? reportResult?.hospitalHeader?.address : reportResult?.address || '',
                zipCode: reportResult?.hospitalHeader?.zipCode ? reportResult?.hospitalHeader?.zipCode : reportResult?.zipCode || '',
                country: reportResult?.hospitalHeader?.country ? reportResult?.hospitalHeader?.country : reportResult?.country || '',
                state: reportResult?.hospitalHeader?.state ? reportResult?.hospitalHeader?.state : reportResult?.state || '',
                city: reportResult?.hospitalHeader?.city ? reportResult?.hospitalHeader?.city : reportResult?.city || '',
                footerAddress: reportResult?.hospitalFooter?.address ? reportResult?.hospitalFooter?.address : reportResult?.address,
                footerContactCountryCode: reportResult?.hospitalFooter?.contactNumberCountryCode || '+91',
                footerContactNumber: getLocalPhoneNumber(reportResult?.hospitalFooter?.contactNumber ? reportResult?.hospitalFooter?.contactNumber : reportResult?.contactNumber),
                footerEmail: reportResult?.hospitalFooter?.email ? reportResult?.hospitalFooter?.email : reportResult?.hospitalEmailId,
            };
            setInitialValues((prev) => ({
                ...prev,
                ...fetchedValues
            }));
            if (fetchedValues.country) {
                fetchStates(fetchedValues.country, '', 'state');
            };
            if (fetchedValues.country && fetchedValues.state) {
                fetchStates(fetchedValues.country, fetchedValues.state, 'city');
            };
        }
    }, [reportResult]);

    useEffect(() => {
        setIsLoading(true);
        dispatch(reportsSettingsApi(reportResult))
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const handleCancel = () => {
        navigate('/dashboard')
    }

    const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        const folderName = 'profile';
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('folderName', folderName);

                dispatch(updateProfileImage(formData))
                    .unwrap()
                    .then((result) => {
                        setProfileImage(result?.result)
                    })
                    .catch((error) => {
                        console.error('Error uploading file:', error);
                    });
            };
            reader.readAsDataURL(file);
        }
    };

    const fetchCommonData = async () => {
        try {
            const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
            if (commonData?.status) {
                setCountryCode(commonData?.result?.countryCode)
                setCountryList(commonData?.result?.countryList)
                setSpecialitities(commonData?.result?.department?.map(item => ({ value: item, label: item })))
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchStates = async (country, state, type) => {
        const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
        if (response?.status) {
            if (type === 'state') {
                setStates(response.result);
            }
            else if (type === 'city') {
                setCities(response.result);
            }
        }
    }

    const handleSaveForm = async (values) => {
        const obj = {
            hospitalId: hospitalId,
            hospitalLogo: profileImage,
            hospitalHeader: {
                hospitalName: values.hospitalName,
                specialitites: values.specialitites,
                contactNumberCountryCode: values.contactNumberCountryCode,
                contactNumber: values.contactNumber,
                email: values.email,
                address: values.address,
                zipCode: values.zipCode,
                country: values.country,
                state: values.state,
                city: values.city,
            },
            hospitalFooter: {
                contactNumberCountryCode: values.footerContactCountryCode,
                contactNumber: values.footerContactNumber,
                email: values.footerEmail,
                address: values.footerAddress,
            },
        };
        dispatch(submitReportsSettingsForm(obj))
    };
    useEffect(() => {
        if (submitReportsSettingsFormResponse?.status === "SUCCESS") {
            setSuccessModal(true);
            setTitle(submitReportsSettingsFormResponse?.msg)
            setTimeout(() => {
                setSuccessModal(false)
                setTitle("")
                navigate('/reportList');
            }, 500)
        }
        else if (submitReportsSettingsFormResponse?.status === 'ERROR') {
            uiNotificationService.show({
                title: "Error",
                type: "error",
                message: submitReportsSettingsFormResponse?.msg,
                position: "bottomRight"
            })
        }
        dispatch(closeUpdateModal())
    }, [submitReportsSettingsFormResponse])
    useEffect(() => {
        fetchCommonData()
        dispatch(getBillingGeneralSettings());
    }, [dispatch])

    useEffect(() => {
    if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
        const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
        setSelectedCountryCode(newCountryCode);
    }
    }, [billingGeneralSettingsData]);

    return (
        <div className='page page__full' style={
            isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
        }>
            <Header isBack={true} title={"Report & Receipt Template"}></Header>
            <div className="page__body">
                <div className='details'>
                    <div className='form form-innersec'>
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={reportsSettingsSchema}
                            onSubmit={handleSaveForm}
                        >
                            {({
                                errors,
                                handleChange,
                                handleBlur,
                                touched,
                                values,
                                setFieldValue,
                                setFieldTouched,
                            }) => (
                                <Form>
                                    <section className='form__section'>
                                        <h1 className='form__section__title'>Header Details</h1>
                                        <div className="formRow formRow__1">
                                            <div className="form__Field">
                                                <label className="form__label" htmlFor="profileImage">Hospital Logo</label>
                                                <label className="form__uploadProfile" htmlFor="uploadProfile">
                                                    {profileImage ? (
                                                        <img className="form__uploadProfile__picture" src={profileImage} />
                                                    ) : (
                                                        <img className="form__uploadProfile__picture" src={ICONS.defaultUserIcon} alt="Default User" />
                                                    )}
                                                    <span className="form__uploadProfile__overlay">
                                                        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15.4782 12.1589C15.4782 12.5125 15.3377 12.8516 15.0877 13.1017C14.8376 13.3517 14.4985 13.4922 14.1449 13.4922H2.14486C1.79124 13.4922 1.4521 13.3517 1.20205 13.1017C0.951999 12.8516 0.811523 12.5125 0.811523 12.1589V4.82552C0.811523 4.4719 0.951999 4.13276 1.20205 3.88271C1.4521 3.63266 1.79124 3.49219 2.14486 3.49219H4.81152L6.14486 1.49219H10.1449L11.4782 3.49219H14.1449C14.4985 3.49219 14.8376 3.63266 15.0877 3.88271C15.3377 4.13276 15.4782 4.4719 15.4782 4.82552V12.1589Z" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M8.14486 10.8255C9.61762 10.8255 10.8115 9.63161 10.8115 8.15885C10.8115 6.68609 9.61762 5.49219 8.14486 5.49219C6.6721 5.49219 5.47819 6.68609 5.47819 8.15885C5.47819 9.63161 6.6721 10.8255 8.14486 10.8255Z" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </label>
                                                <input type="file" id="uploadProfile" className="form__uploadfiled" ref={fileInputRef} onChange={handleImageChange} />
                                            </div>
                                        </div>
                                        <div className='formRow formRow__3'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='hospitalName'>
                                                        Hosptial Name
                                                        <span className="required-asterisk">*</span>
                                                    </label>
                                                    <input className="form__input form__input--sm"
                                                        type="text"
                                                        id="hospitalName"
                                                        name="hospitalName"
                                                        placeholder="Hospital Name"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.hospitalName}
                                                        autoComplete='off'
                                                    />
                                                    <ErrorMessage name="hospitalName" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                        <div className='formCol'>
                                            <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Contact Number<span className="required-asterisk">*</span>
                                                    </label>
                                                    <div className='form__groupField form__groupField--phonenumber'>
                                                        <select className="form__select form__select--sm"
                                                            style={customStyle.select}
                                                            id="contactNumberCountryCode"
                                                            name="contactNumberCountryCode"
                                                            value={values.contactNumberCountryCode}

                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                setFieldValue('whatsappCountryCode', e.target.value);  // Update whatsappNumber if checkbox is checked
                                                                setFieldValue('whatsappNumber', values?.contactNumber);
                                                            }}>
                                                            {countryCode.map((option) => (
                                                                <option 
                                                                key={option} 
                                                                value={option}
                                                                >
                                                                {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <input type="text"
                                                            className="form__input form__input--sm"
                                                            id="contactNumber"
                                                            name="contactNumber"
                                                            placeholder="Contact Number"
                                                            maxLength={10}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                setFieldValue('whatsappNumber', e.target.value);  // Update whatsappNumber if checkbox is checked
                                                                setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode);
                                                            }}
                                                            onInput={(e) => {
                                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                handleChange(e);
                                                            }}
                                                            pattern="[0-9]*"
                                                            onBlur={handleBlur}
                                                            value={values.contactNumber}
                                                            autoComplete='off'>
                                                        </input>
                                                    </div>

                                                    <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                            <div className="form__Field">
                                                <label className='form__label' htmlFor='specialitites'>
                                                    Specialities
                                                    <span className="required-asterisk">*</span>
                                                </label>
                                                <Select
                                                    id='specialitites'
                                                    placeholder='Select'
                                                    className='cutom-bg-white'
                                                    isMulti={true}
                                                    isClearable={false}
                                                    isSearchable={false}
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    options={specialitites}
                                                    value={values.specialitites}
                                                    onChange={(selectedOptions) => {
                                                        const newSpecialties = selectedOptions ? selectedOptions.map(option => option) : [];
                                                        setFieldValue('specialitites', newSpecialties);
                                                    }
                                                    }
                                                ></Select>
                                                <ErrorMessage name="specialitites" component="div" className="error text-error" />
                                            </div>
                                        </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className='formRow formRow__2'>
                                                    <div className='formCol'>
                                                        <div className="form__Field">
                                                            <label className="form__label">
                                                                Email ID<span className="required-asterisk">*</span>
                                                            </label>
                                                            <input
                                                                className="form__input form__input--sm"
                                                                type="email"
                                                                id="email"
                                                                name="email"
                                                                placeholder="Email ID"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.email}
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="email" component="div" className="error text-error" />
                                                        </div>
                                                    </div>
                                                    <div className='formCol'>
                                                        <div className="form__Field">
                                                            <label className="form__label">
                                                                Address<span className="required-asterisk">*</span>
                                                            </label>
                                                            <input
                                                                className="form__input form__input--sm"
                                                                type="text"
                                                                id="address"
                                                                name="address"
                                                                placeholder="Address"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.address}
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="address" component="div" className="error text-error" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="formRow formRow__4">
                                                    <div className='formCol'>
                                                        <div className='form__Field'>
                                                            <label className="form__label" htmlFor='zipCode'>Zip Code<span className="required-asterisk">*</span></label>
                                                            <input
                                                                className="form__input form__input--sm"
                                                                type="text"
                                                                id="zipCode"
                                                                name="zipCode"
                                                                placeholder="Zip Code"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.zipCode}
                                                                autoComplete='off'
                                                            />
                                                        </div>
                                                        <ErrorMessage name="zipCode" component="div" className="error text-error" />
                                                    </div>
                                                    <div className='formCol'>
                                                        <div className='form__Field'>
                                                            <label className="form__label" htmlFor='country'>Country<span className="required-asterisk">*</span></label>
                                                            <select
                                                                id="country"
                                                                name="country"
                                                                className="form__select form__select--sm"
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    fetchStates(e.target.value, '', 'state')
                                                                }}
                                                                onBlur={handleBlur}
                                                                value={values.country}
                                                                autoComplete='off'
                                                                style={customStyle.select}
                                                            >
                                                                <option value="">Select</option>
                                                                {countryList.map((option) => (
                                                                    <option key={option.value} value={option.value}>
                                                                        {option.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <ErrorMessage name="country" component="div" className="error text-error" />
                                                    </div>
                                                    <div className='formCol'>
                                                        <div className='form__Field'>
                                                            <label className="form__label" htmlFor='state'>State<span className="required-asterisk">*</span></label>
                                                            <select
                                                                style={customStyle.select}
                                                                id="state"
                                                                name="state"
                                                                className="form__select form__select--sm"
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    fetchStates(values.country, e.target.value, 'city')
                                                                }}
                                                                onBlur={handleBlur}
                                                                value={values.state}
                                                                autoComplete='off'
                                                            >
                                                                <option value="">Select</option>
                                                                {states.map((option) => (
                                                                    <option key={option.isoCode} value={option.isoCode}>
                                                                        {option.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <ErrorMessage name="state" component="div" className="error text-error" />
                                                    </div>
                                                    <div className='formCol'>
                                                        <div className='form__Field'>
                                                            <label className="form__label" htmlFor='city'>City<span className="required-asterisk">*</span></label>
                                                            <select
                                                                style={customStyle.select}
                                                                id="city"
                                                                name="city"
                                                                className="form__select form__select--sm"
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values.city}
                                                                autoComplete='off'
                                                            >
                                                                <option value="">Select</option>
                                                                {cities.map((option) => (
                                                                    <option key={option.name} value={option.name}>
                                                                        {option.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <ErrorMessage name="city" component="div" className="error text-error" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    <section className='form__section'>
                                        <h1 className='form__section__title'>Footer Details</h1>
                                        <div className='formRow formRow__3'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='footerContactNumber'>
                                                        Contact Number<span className="required-asterisk">*</span>
                                                    </label>
                                                    <div className='form__groupField form__groupField--phonenumber'>
                                                        <select className="form__select form__select--sm"
                                                            style={customStyle.select}
                                                            id="footerContactCountryCode"
                                                            name="footerContactCountryCode"
                                                            value={values.footerContactCountryCode}

                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                setFieldValue('whatsappCountryCode', e.target.value);  // Update whatsappNumber if checkbox is checked
                                                                setFieldValue('whatsappNumber', values?.footerContactCountryCode);
                                                            }}>
                                                            {countryCode.map((option) => (
                                                                <option 
                                                                key={option} 
                                                                value={option}
                                                                >
                                                                {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <input type="text"
                                                            className="form__input form__input--sm"
                                                            id="footerContactNumber"
                                                            name="footerContactNumber"
                                                            placeholder="Contact Number"
                                                            maxLength={10}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                setFieldValue('whatsappNumber', e.target.value);  // Update whatsappNumber if checkbox is checked
                                                                setFieldValue('whatsappCountryCode', values?.footerContactNumber);
                                                            }}
                                                            onInput={(e) => {
                                                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                                handleChange(e);
                                                            }}
                                                            pattern="[0-9]*"
                                                            onBlur={handleBlur}
                                                            value={values.footerContactNumber}
                                                            autoComplete='off'>
                                                        </input>
                                                    </div>

                                                    <ErrorMessage name="footerContactCountryCode" component="div" className="error text-error" />
                                                    <ErrorMessage name="footerContactNumber" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='footerEmail'>
                                                        Email ID<span className="required-asterisk">*</span>
                                                    </label>
                                                    <input
                                                        className="form__input form__input--sm"
                                                        type="text"
                                                        id="footerEmail"
                                                        name="footerEmail"
                                                        placeholder="Email ID"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.footerEmail}
                                                        autoComplete='off'
                                                    />
                                                    <ErrorMessage name="footerEmail" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label">
                                                        Address<span className="required-asterisk">*</span>
                                                    </label>
                                                    <input
                                                        className="form__input form__input--sm"
                                                        type="text"
                                                        id="footerAddress"
                                                        name="footerAddress"
                                                        placeholder="Address"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.footerAddress}
                                                        autoComplete='off'
                                                    />
                                                    <ErrorMessage name="footerAddress" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className='btn__group'>
                                            <button
                                                className='btn btn__primary'
                                                type="submit"

                                            >
                                                Save
                                            </button>
                                            <button
                                                className='btn btn__white'
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </section>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
            <SuccessModal
                isSuccessModalOpen={successModal}
                title={title}
                handleCloseModal={() => setSuccessModal(false)}
            />
            <Loader
                isLoaderOpen={isLoading || submitReportsSettingsFormResponse.loading}
            />
        </div>
    )
}

export default ReportsSettings
